export default __webpack_public_path__ + "static/shape1-0704f52a695066025638b084bc4bb5f3.png";